import { useState, useEffect } from "react";
import { simplePostcodeRegex } from "../../../utils/regexes";

type PostcodeLookupError = "NOT_FOUND" | "OUTSIDE_SERVICE_AREA" | null;

interface UsePostcodeLookupResult {
  addresses: string[];
  isLoading: boolean;
  error: PostcodeLookupError;
}

export function usePostcodeLookup(postcode: string | undefined): UsePostcodeLookupResult {
  const [isLoading, setIsLoading] = useState(false);
  const [addresses, setAddresses] = useState<string[]>([]);
  const [error, setError] = useState<PostcodeLookupError>(null);

  useEffect(() => {
    setError(null);

    const fetchPostcodeData = async () => {
      if (simplePostcodeRegex.test(postcode ?? "")) {
        setIsLoading(true);
        const response = await fetch(`/postcode-lookup?postcode=${encodeURIComponent(postcode ?? "")}`);
        setIsLoading(false);

        if (response.ok) {
          const data = (await response.json()) as string[];
          setAddresses(data);
          setError(null);
        } else if (response.status === 404) {
          setAddresses([]);
          setError("NOT_FOUND");
        } else if (response.status === 422) {
          setAddresses([]);
          setError("OUTSIDE_SERVICE_AREA");
        }
      } else {
        setAddresses([]);
        setError(null);
      }
    };

    void fetchPostcodeData();
  }, [postcode]);

  return { addresses, isLoading, error };
}
